import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import BuyOption from './BuyOption.js';
import VideoComponent from './VideoComponent.js';

// ES6 class-style
class TeacherBuy extends PreLoginSessionCheck {
	constructor(props) {
		super(props);
		this.productDetails = localStorage.getItem('proDetail');

		this.getBuyOptions = this.getBuyOptions.bind(this);
	}

	getProductDetails(){
		//console.log(JSON.parse(this.productDetails));
		if(this.productDetails != {} && this.productDetails != undefined){
			return JSON.parse(this.productDetails);
		}else{
			return {};
		}
	}


	componentDidMount(){
		/* var clsName=this.removeWhiteSpace(this.getProductDetails()[this.props.id].ClassName)
		this.setTitle(clsName+"_title");
		this.setMeta(clsName+"_meta");
		this.setHeading(clsName+"_heading"); */
	}

	
	getBuyOptions(){
		return (<BuyOption showContactus={this.props.showContactus}  id={this.props.id} triedFree={this.props.triedFree} purchased={this.props.purchased} showSubScripeLoginForm={this.props.showSubScripeLoginForm} productBase={this.props.productBase} simpleform={this.props.simpleform} role={"TCHR"}></BuyOption>);
	}

  render() {
  	//var classname = this.getProductDetails()[this.props.id].ClassName;
  	return(
  		<section className="mtb yellow-child">
  		<div className="container tchrbuy"> 
        {/* <h3>Advance your career and scale your impact by joining our community!</h3> */}
		<h2>{this.rb("Tchrcomp.subheading")}<br/>
		{this.rb("Tchrcomp.subheading1")}</h2>
  		{/* <hr className="buyoptionline"/>
  		{this.getBuyOptions()} */}
  		</div> 
  		</section>
  		);
  	}
  }

  export default TeacherBuy;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/TeacherBuy.js